import React from 'react';
import ProjectPhoto from './ProjectPhoto';
import './ProjectGallery.css';

export default function ProjectGallery({ photos }) {
  return <div className="project-photo-grid">
    {photos.map(photo => <figure className="project-photo" key={photo.id}>
      <a href={photo.image} target="_blank" rel="noreferrer" aria-label={`View full photo: ${photo.title} (opens in a new tab)`}>
        <ProjectPhoto src={photo.image} alt={photo.alt} loading="lazy" />
        <span className="project-photo-expand" aria-hidden="true">View photo ↗</span>
      </a>
      <figcaption><p className="eyebrow">{photo.category}</p><h3>{photo.title}</h3></figcaption>
    </figure>)}
  </div>;
}
